import styleInject from '../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".MovErrorBox-module_box__SqAJf {\n  border-radius: var(--pp-radius-s, 8px);\n  background-color: var(--pp-color-special-autoshipmentLight);\n  padding: 10px 10px 1px 10px;\n}";
var styles = {"box":"MovErrorBox-module_box__SqAJf"};
styleInject(css_248z,{"insertAt":"top"});

export { styles as default };
//# sourceMappingURL=MovErrorBox.module.scss.js.map
